import Insights from 'mage-insights';
const BASE_EVENT_CATEGORY_BPC = 'generic-onboarding';
export const trackInsightsEvent = (event) => {
    try {
        Insights.event(event);
    }
    catch (err) {
        // eslint-disable-next-line no-console
        console.error('There was an error while pushing insights event', err);
    }
};
export var BPC_INSIGHT_EVENTS;
(function (BPC_INSIGHT_EVENTS) {
    BPC_INSIGHT_EVENTS["APPLICATION_SUBMITTED"] = "APPLICATION_SUBMITTED";
    BPC_INSIGHT_EVENTS["TERMS_AND_CONDITIONS_SUBMITTED"] = "TERMS_AND_CONDITIONS_SUBMITTED";
})(BPC_INSIGHT_EVENTS || (BPC_INSIGHT_EVENTS = {}));
export const createBPCInsightEventCategory = (eventType) => {
    return `${BASE_EVENT_CATEGORY_BPC}/${eventType}`;
};
